export default "__VITE_ASSET__D8YWl5L1__"